// Single list of blog posts, used by the blog index. Posts with `path` have their own page.
export const SERIES = {
  'under-the-hood': {
    name: 'Under the Hood',
    blurb: 'How Panda works inside, with the numbers from our own testing.',
  },
};

export const blogPosts = [
  {
    id: 'how-byok-works',
    path: '/blog/how-byok-works',
    title: 'How the BYOK plan works',
    excerpt:
      'Bring your own model key and a Jev key. They stay on your phone, and BYOK mode sends your thinking and quick decisions through those keys.',
    date: 'October 2026',
    category: 'Product',
    readTime: '4 min read',
  },
  {
    id: 'chat-reply',
    path: '/blog/chat-reply',
    title: 'A reply, ready when the keyboard opens',
    excerpt:
      'When the keyboard opens in a chat, Panda can draft a reply into the box. You still send it yourself.',
    date: 'October 2026',
    category: 'Product',
    readTime: '4 min read',
    featured: true,
  },
  {
    id: 'panda-gets-reflexes',
    path: '/blog/panda-gets-reflexes',
    title: 'Panda Gets Reflexes',
    excerpt:
      'We put a fast classifier in front of the LLM in our phone agent. Most screen decisions now take about 0.4 seconds, and Panda knows when to stop and think.',
    date: 'October 2026',
    category: 'Engineering',
    readTime: '8 min read',
    series: 'under-the-hood',
    part: 1,
  },
  {
    id: 'panda-story',
    title: 'The Story Behind Panda',
    excerpt: 'How 26K users came together in 15 days, and the people who made it possible',
    date: 'January 2025',
    category: 'Story',
    readTime: '5 min read',
  },
  {
    id: 'accessibility-focus',
    title: 'Why We Build for Accessibility',
    excerpt: 'A deep dive into our mission to help visually impaired users regain digital independence.',
    date: 'February 2025',
    category: 'Mission',
    readTime: '4 min read',
  },
];

export const postHref = (post) => post.path || `/blog/${post.id}`;
